module.exports = __webpack_public_path__ + "img/1525544355.9ffc7662.jpg";